import React, { FunctionComponent } from 'react';
import { DefaultSeo } from 'next-seo';
import { Router } from 'next/router';
import { useLocalization } from '@bumble/localization/components';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

const APP_NAME = 'Bumble';

type PageSeoProps = {
    lang: SupportedLanguage;
    router: Router;
};

const PageSeo: FunctionComponent<PageSeoProps> = ({ lang, router }) => {
    const Localization = useLocalization();

    /* Use appType to switch between different SEO tags */
    return (
        <DefaultSeo
            languageAlternates={getLanguageAlternates(router)}
            canonical={getCanonical(router)}
            facebook={{
                appId: 'bumble-join-hives',
            }}
            additionalMetaTags={[
                {
                    name: 'apple-itunes-app',
                    content: 'app-id=930441707',
                },
                {
                    property: 'p:domain_verify',
                    content: '26cd87d4b7db08a05bdfa2219d3671b6',
                },
                {
                    property: 'referrer',
                    content: 'origin-when-cross-origin',
                },
                {
                    property: 'twitter:app:name:iphone',
                    content: APP_NAME,
                },
                {
                    property: 'twitter:app:id:iphone',
                    content: '930441707',
                },
            ]}
            openGraph={{
                type: 'website',
                locale: lang,
                url: getCanonical(router),
                site_name: APP_NAME,
                title: Localization.get('bumblesite@join_hives.link_preview.header'),
                description: Localization.get('bumblesite@join_hives.link_preview.body'),
                images: [
                    {
                        url: 'https://pd1us.bumbcdn.com/i/big/assets/static_images/bumble-fb-share.png?v2',
                        alt: APP_NAME,
                        width: 1200,
                        height: 630,
                    },
                ],
            }}
            twitter={{
                handle: '@bumble',
                cardType: 'summary_large_image',
                site: '@bumble',
            }}
        />
    );
};

/**
 * Returns "alternate" languages for SEO
 */
function getLanguageAlternates(_router: Router) {
    return [];
}

function getCanonical(_router: Router) {
    return '';
}

export default PageSeo;
